import { createContext, useContext } from 'react';

export interface StaticPageContextValue {
  pageId?: string;
  siteId?: string;
  pageSlug?: string;
  studioAppOrigin?: string;
}

export const StaticPageContext = createContext<StaticPageContextValue>({});

export const useStaticPageContext = () => useContext(StaticPageContext);
